import { useEffect, useState } from "react";
import CustomModal from "../CustomModal/CustomModal";
import Button from "../Button/Button";

export default function PushUnsupportedModal() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handle = () => setOpen(true);
    window.addEventListener("push-not-supported", handle);
    return () => window.removeEventListener("push-not-supported", handle);
  }, []);

  return (
    <CustomModal
      show={open}
      handleClose={() => setOpen(false)}
      title={
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <span style={{ fontSize: 22 }}>🔔</span>
          <span>Push Notifications Unavailable</span>
        </div>
      }
      isFooterVisible
      footerContent={
        <Button className="btn teal" onClick={() => setOpen(false)}>
          Got it
        </Button>
      }
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        <p
          style={{
            margin: 0,
            color: "var(--tx)",
            fontSize: 14,
            lineHeight: 1.6,
          }}
        >
          Your browser doesn't support push notifications, so you won't receive
          real-time alerts in the background.
        </p>
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            gap: 12,
            padding: "12px 14px",
            background: "var(--bg3)",
            borderRadius: 8,
            border: "1px solid var(--bd)",
          }}
        >
          <span style={{ fontSize: 20, lineHeight: 1 }}>🔔</span>
          <p
            style={{
              margin: 0,
              color: "var(--tx2)",
              fontSize: 13,
              lineHeight: 1.6,
            }}
          >
            All your notifications are still available — click the{" "}
            <strong style={{ color: "var(--tx)" }}>bell icon</strong> in the top
            bar anytime to view them.
          </p>
        </div>
      </div>
    </CustomModal>
  );
}
